// This file was auto-generated by querybuilder/Apollo and should not be edited.

import * as ExtendedFormFieldErrors from './ExtendedFormFieldErrors';
import * as OnboardingScaffolding from './OnboardingScaffolding';
/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

import { OnboardingStep1V2Input } from "./globalTypes";

// ====================================================
// GraphQL mutation operation: OnboardingStep1V2Mutation
// ====================================================

export interface OnboardingStep1V2Mutation_output_errors_extendedMessages {
  /**
   * A human-readable validation error.
   */
  message: string;
  /**
   * A machine-readable representation of the error.
   */
  code: string | null;
}

export interface OnboardingStep1V2Mutation_output_errors {
  /**
   * The camel-cased name of the input field, or '__all__' for non-field errors.
   */
  field: string;
  /**
   * A list of validation errors with extended metadata.
   */
  extendedMessages: OnboardingStep1V2Mutation_output_errors_extendedMessages[];
}

export interface OnboardingStep1V2Mutation_output_session_onboardingScaffolding {
  firstName: string;
  lastName: string;
  preferredFirstName: string;
  street: string;
  city: string;
  isCityInNyc: boolean | null;
  /**
   * Whether the onboarding user is in Los Angeles County. If we don't have enough information to tell, this will be null.
   */
  isInLosAngeles: boolean | null;
  state: string;
  borough: string;
  zipCode: string;
  aptNumber: string | null;
  email: string;
  phoneNumber: string;
  leaseType: string;
  receivesPublicAssistance: boolean | null;
  hasLandlordEmailAddress: boolean | null;
  hasLandlordMailingAddress: boolean | null;
  canReceiveRttcComms: boolean | null;
  canReceiveSajeComms: boolean | null;
}

export interface OnboardingStep1V2Mutation_output_session {
  onboardingScaffolding: OnboardingStep1V2Mutation_output_session_onboardingScaffolding | null;
}

export interface OnboardingStep1V2Mutation_output {
  /**
   * A list of validation errors in the form, if any. If the form was valid, this list will be empty.
   */
  errors: OnboardingStep1V2Mutation_output_errors[];
  session: OnboardingStep1V2Mutation_output_session | null;
}

export interface OnboardingStep1V2Mutation {
  output: OnboardingStep1V2Mutation_output;
}

export interface OnboardingStep1V2MutationVariables {
  input: OnboardingStep1V2Input;
}

export const BlankOnboardingStep1V2Input: OnboardingStep1V2Input = {
  "address": "",
  "borough": "",
  "aptNumber": "",
  "noAptNumber": false,
  "firstName": "",
  "lastName": "",
  "preferredFirstName": ""
};

export const OnboardingStep1V2Mutation = {
  // The following query was taken from OnboardingStep1V2Mutation.graphql.
  graphQL: `# This file was auto-generated by querybuilder, please do not edit it.
mutation OnboardingStep1V2Mutation($input: OnboardingStep1V2Input!) {
  output: onboardingStep1V2(input: $input) {
    errors { ...ExtendedFormFieldErrors },
    session {
      onboardingScaffolding { ...OnboardingScaffolding }
    }
  }
}
${ExtendedFormFieldErrors.graphQL}
${OnboardingScaffolding.graphQL}`,
  name: "OnboardingStep1V2Mutation",
  fetch(fetchGraphQL: (query: string, args?: any) => Promise<any>, args: OnboardingStep1V2MutationVariables): Promise<OnboardingStep1V2Mutation> {
    return fetchGraphQL(OnboardingStep1V2Mutation.graphQL, args);
  },
  blankInput: BlankOnboardingStep1V2Input,
};

export const fetchOnboardingStep1V2Mutation = OnboardingStep1V2Mutation.fetch;